"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.myAppointmentWishEntry = exports.myAppointmentWish = exports.appointmentOrderPropType = exports.appointmentGapPropType = exports.appointmentGapList = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var appointmentOrderPropType = exports.appointmentOrderPropType = {
  isDatePlannable: _propTypes.default.bool.isRequired,
  isDateCancellable: _propTypes.default.bool.isRequired,
  isDateRequestable: _propTypes.default.bool.isRequired,
  appointment: _propTypes.default.shape({
    from: _propTypes.default.string.isRequired,
    to: _propTypes.default.string.isRequired
  }),
  meterInstallationServiceProvider: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    phone: _propTypes.default.string.isRequired
  }),
  blocked: _propTypes.default.arrayOf(_propTypes.default.shape({
    from: _propTypes.default.string.isRequired,
    to: _propTypes.default.string.isRequired
  }))
};
/**
 * Data of UI and API call
 */
var appointmentGapPropType = exports.appointmentGapPropType = {
  gapId: _propTypes.default.string.isRequired,
  isGreen: _propTypes.default.bool.isRequired,
  appointment: _propTypes.default.shape({
    from: _propTypes.default.string.isRequired,
    to: _propTypes.default.string.isRequired
  }).isRequired
};
var appointmentGapList = exports.appointmentGapList = {
  assOrderId: _propTypes.default.string.isRequired,
  gaps: _propTypes.default.arrayOf(_propTypes.default.shape(appointmentGapPropType))
};

/**
 * Data of api call
 */
var myAppointmentWishEntry = exports.myAppointmentWishEntry = {
  weekday: _propTypes.default.string.isRequired,
  from: _propTypes.default.string.isRequired,
  to: _propTypes.default.string.isRequired
};
var myAppointmentWish = exports.myAppointmentWish = {
  earliestDate: _propTypes.default.string.isRequired,
  proposals: _propTypes.default.arrayOf(_propTypes.default.shape(myAppointmentWishEntry))
};